<template>
  <div v-if="isOpen">
    <div class="filter-wrapper" @click="closeBlock"></div>

    <div class="filter">
      <!-- <fieldset>
      <label>
        <input type="radio" />

        Від А до Я
      </label>

      <label>
        <input type="radio" />

        Від Я до А
      </label>
    </fieldset> -->

      <!-- <fieldset>
      <label>
        <input type="radio" />

        Ім'я
      </label>

      <label>
        <input type="radio" />

        Email
      </label>
    </fieldset> -->

      <div class="search-input-wrapper" v-if="!disabledSearch">
        <div class="search-input-logo">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Search">
              <circle id="Ellipse_739" cx="9.76639" cy="9.76688" r="8.98856" stroke="#C3CCD9" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
              <path id="Line_181" d="M16.0181 16.4854L19.5421 20.0002" stroke="#C3CCD9" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </g>
          </svg>
        </div>

        <input type="text" class="search-input" v-model="searchInputValue" />
      </div>

      <ul v-if="(renderedList && renderedList.length > 0)">
        <li v-for="item in renderedList" :key="item.id">
          <label>
            <input type="checkbox" :value="item.name" v-model="localSelected" />

            {{ item.name | translate }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'filter-by-name',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: ['isOpen', 'filterList', 'selected', 'close', 'disabledSearch'],
  data() {
    return {
      localSelected: [],
      searchInputValue: ''
    }
  },
  methods: {
    closeBlock() {
      this.$emit('close')
    }
  },
  watch: {
    localSelected(value) {
      this.$emit('change', value)
    }
  },
  computed: {
    renderedList() {
      return this.filterList.filter(i => i.name.toLowerCase().includes(this.searchInputValue.toLowerCase()))
    }
  }
}
</script>

<style lang="scss">
.filter-wrapper {
  position: fixed;

  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 4;
}

.filter {
  display: block;
  position: absolute;

  top: 40px;
  left: 0;

  padding: 10px;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

  background-color: #fff;

  z-index: 5;

  & ul {
    padding: 5px;

    margin: 10px 0;

    max-height: 250px;

    overflow: auto;
  }

  & li {
    list-style-type: none;

    // 

    color: #150722;
  }

  // & input[type='checkbox'] {
  //   accent-color: #5DCF3C;
  //   background-color: #5DCF3C;

  //   border: double 2px #00F
  // }
}

.search-input-wrapper {
  position: relative;

  .search-input-logo {
    position: absolute;

    top: 5px;
    left: 10px;
  }

  .search-input {
    width: 300px;
    padding: 5px 5px 5px 40px;
    align-items: center;

    border-radius: 8px;
    border: 1px solid #B7AFBF;
  }
}
</style>